if (!customElements.get('custom-sticky-atc')) {
  customElements.define(
    'custom-sticky-atc',
    class CustomStickyAtc extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-sticky-atc-button]');
        this.errorEl = this.querySelector('[data-sticky-atc-error]');
        this.button?.addEventListener('click', () => this.addToCart());

        this.resizeObserver = new ResizeObserver(() => {
          document.body.style.setProperty('--sticky-atc-height', `${this.offsetHeight}px`);
        });
        this.resizeObserver.observe(this);

        if (this.dataset.alwaysVisible === 'true') {
          this.setVisible(true);
          return;
        }

        // Show the bar only once the main Add to cart button has scrolled up past the top of the
        // screen, so it stays hidden everywhere above (and alongside) that button.
        const mainButton = document.querySelector('product-info [id^="ProductSubmitButton-"]');
        if (!mainButton) {
          this.setVisible(true);
          return;
        }
        this.observer = new IntersectionObserver(([entry]) =>
          this.setVisible(!entry.isIntersecting && entry.boundingClientRect.bottom <= 0)
        );
        this.observer.observe(mainButton);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        document.body.classList.remove('sticky-atc-open');
      }

      setVisible(visible) {
        this.classList.toggle('is-visible', visible);
        this.inert = !visible;
        document.body.classList.toggle('sticky-atc-open', visible);
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message || '';
        this.errorEl.hidden = !message;
      }

      // Same request as the theme's product form, so the cart drawer and cart count update as usual.
      addToCart() {
        if (!this.button || this.button.disabled || this.button.classList.contains('is-loading')) return;

        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const variantId = this.dataset.variantId;
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);
        if (cart) {
          formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement(this.button);
        }

        this.showError('');
        this.button.classList.add('is-loading');
        this.button.setAttribute('aria-busy', 'true');

        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.showError(response.description || response.message);
              return;
            }
            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }
            if (typeof publish === 'function') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'sticky-atc',
                productVariantId: variantId,
                cartData: response,
              });
            }
            cart.classList.remove('is-empty');
            cart.renderContents(response);
          })
          .catch((error) => {
            console.error(error);
            this.showError(window.cartStrings?.error);
          })
          .finally(() => {
            this.button.classList.remove('is-loading');
            this.button.removeAttribute('aria-busy');
          });
      }
    }
  );
}
